import { Stack, Typography } from '@mui/material';
import { TerminalIcon } from 'lucide-react';

export const CLIEmptyState = () => {
  return (
    <Stack alignItems="center" gap={1} justifyContent="center">
      <TerminalIcon size={32} />
      <Typography fontSize={14} fontWeight={500}>
        No feedback yet
      </Typography>
      <Typography fontSize={14} fontWeight={500} color="text.disabled">
        System responses will appear here
      </Typography>
    </Stack>
  );
};
